import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Apply from "@/pages/Apply";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminPortal from "@/pages/AdminPortal";
import SettingsPage from "@/pages/SettingsPage";
import BookingResult from "@/pages/BookingResult";
import LegalCenter from "@/pages/LegalCenter";
import "@/App.css";

function ProtectedLayout({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  useEffect(() => {
    document.title = "LAZ Coach — Mindset & Executive Leadership Coaching";
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <PWAInstallPrompt />
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            classNames: {
              toast:
                "!font-sans !rounded-2xl !border-stone-200 !bg-stone-50 !text-stone-900",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/booking/success" element={<BookingResult outcome="success" />} />
          <Route path="/booking/cancel" element={<BookingResult outcome="cancel" />} />
          <Route path="/legal" element={<LegalCenter />} />
          <Route path="/legal/:document" element={<LegalCenter />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedLayout>
                <ClientDashboard />
              </ProtectedLayout>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedLayout roles={["admin"]}>
                <AdminPortal />
              </ProtectedLayout>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedLayout>
                <SettingsPage />
              </ProtectedLayout>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
